import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { hashUrl, navbatKey } from "url"

const baseUrl = hashUrl

export const salonOwnerHashApi = createApi({
  reducerPath: "salonOwnerHashApi",
  // baseQuery: fetchBaseQuery({ baseUrl }),
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      headers.set("Navbat-key", navbatKey)

      return headers
    },
  }),
  tagTypes: ["SalonOwner"],
  endpoints: (builder) => ({
    getByHash: builder.query({
      query: (hash) => `client/v1/salons/s/${hash}`,
    }),

    postUpdateCallRequest: builder.mutation({
      query: ({ hash, callRequested }) => ({
        url: `client/v1/salons/${hash}/update-call-request`,
        method: "POST",
        body: { call_requested: callRequested },
      }),
    }),
  }),
})


export const { useGetByHashQuery, usePostUpdateCallRequestMutation } = salonOwnerHashApi;
